<template>
  <div class="mine-studentMessage-grade-gradeAdd">
      <div class="contentBox">
        <table class="gradeTable">
          <thead>
            <tr>
              <th width='130'>科目</th>
              <th width='100'>分数</th>
              <th width='100'>年级人数</th>
              <th width='100'>单科排名</th>
              <th width='120'>年级总排名</th>
              <th>考试说明</th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="(item,index) in data.subject" :key="index">
                <td>{{item.subject}}</td>
                <td>{{item.score}}</td>
                <td>{{item.totalPeople}}</td>
                <td>{{item.rank}}/{{item.totalPeople}}</td>
                <td v-if="index==0" :rowspan="data.subject.length">{{data.totalRank}}/{{data.totalPeople}}</td>
                <td>
                  <p style="display: flex;align-items: center;line-height: 24px;justify-content: center;padding: 0 10px">{{item.remark}}</p>
                </td>
              </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>
<script>
export default {
  name: "gradeDetail",
  props:['id'],
  data(){
    return{
      data: {}
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.grade.detailAchievement, {
        id:this.id
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          console.log(res.data.data)
          this.data=res.data.data
        }else{

        }
      })
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
    @import "./css/gradeAdd.less";
</style>